import { useState, useEffect, useContext } from "react";
import { Modal } from "react-bootstrap";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip";
import CustomButton from "../kits/button/CustomButton";
import { CustomInput, ReactSelect } from "../kits/Inputs/Inputs.tsx";
import DatePiker from "../datepiker/datePiker.jsx";
import ToastCustomize from "../kits/ToastCustomize";
import useAxios from "../../services/useAxios.tsx";
import { EntryIcon } from "../kits/Icons.tsx";

import AuthenticationContext from "../../Authentication/AuthenticationContext";

export default function EntryStorageModal({ data, users, setUpdater }) {
  const { execute: registerApi } = useAxios("api2/receipt_registration");

  const { userInfo } = useContext(AuthenticationContext);
  const [entryShow, setEntryShow] = useState(false);
  const [entryStorage, setEntryStorage] = useState({
    count: "",
    sender: [],
    description: "",
    date: "",
  });
  const [validate, setValidate] = useState({
    count: true,
    date: true,
    user: true,
  });
  const validation = () => {
    let isValid = true;
    if (entryStorage.count == "") {
      isValid = false;
      setValidate((prev) => {
        return { ...prev, count: false };
      });
    }
    if (entryStorage.date == "") {
      isValid = false;
      setValidate((prev) => {
        return { ...prev, date: false };
      });
    }
    if (entryStorage.sender.length == 0) {
      isValid = false;
      setValidate((prev) => {
        return { ...prev, user: false };
      });
    }
    return isValid;
  };

  const clearData = () => {
    setValidate({
      count: true,
      date: true,
      user: true,
    });
    setEntryStorage({
      count: "",
      sender: [],
      description: "",
      date: "",
    });
  };

  const enterBill = () => {
    // pServiceId,type,count,whiteHouseItemId,reciverId,senderId,status,usertoken
    let fd = new FormData();
    fd.append("pServiceId", data.product_services__id);
    fd.append("type", 1);
    fd.append("count", entryStorage.count);
    fd.append("whiteHouseItemId", data.white_house_item__id);
    fd.append("reciverId", userInfo.id);
    fd.append("senderId", entryStorage.sender?.value);
    fd.append("status", 1);
    fd.append("description", entryStorage.description);
    fd.append("do_tm", entryStorage.date);
    registerApi(fd).then((data) => {
      if (data.status == 1) {
        ToastCustomize({
          mainText: " ورود به انبار با موفقیت ثبت شد",
          duration: 3000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
        setEntryStorage({
          count: "",
          sender: [],
          description: "",
          date: "",
        });
        setEntryShow(false);
        setUpdater((prev) => !prev);
      } else {
        ToastCustomize({
          mainText: "مشکلی در ثبت پیش آمد",
          duration: 3000,
          toastType: "warning",
          color: "warning",
          position: "top-center",
          hasHeader: false,
        });
        setEntryStorage({
          count: "",
          sender: [],
          description: "",
          date: "",
        });
        setEntryShow(false);
      }
    });
  };
  return (
    <>
      {userInfo.userRoll.includes(39) && (
        <CustomTooltip
          title="ورود به انبار"
          placement="top"
          color="secondary_custom"
        >
          <div>
            <CustomButton
              className="shadow-none"
              onClick={() => {
                setEntryShow(true);
              }}
            >
              <EntryIcon color="white" />
            </CustomButton>
          </div>
        </CustomTooltip>
      )}
      <Modal
        show={entryShow}
        onHide={() => {
          setEntryShow(false);
          clearData();
        }}
      >
        <Modal.Header closeButton>ورود به انبار</Modal.Header>
        <Modal.Body>
          <div className="px-3">
            <div className="mt-4">
              <CustomInput
                type="text"
                label="نام محصول"
                activate="disabled"
                inputValue={data?.title}
              ></CustomInput>
            </div>
            <div className="mt-4">
              <CustomInput
                type="text"
                label="تعداد"
                // textErr={`${!validate.count && "تعداد را وارد کنید"} `}
                inputValue={entryStorage.count}
                onChangeFunc={(e) => {
                  setEntryStorage((prev) => {
                    return { ...prev, count: e.target.value };
                  });
                }}
              ></CustomInput>
              <p
                className="text-danger mt-1"
                style={{
                  display: validate.count ? "none" : "block",
                  fontSize: 10,
                }}
              >
                تعداد را وارد کنید
              </p>
            </div>
            <div className="mt-4">
              <ReactSelect
                title="کاربر تحویل دهنده"
                itemsList={users}
                inputValue={entryStorage.sender}
                onChangeFunc={(e) => {
                  setEntryStorage((prev) => {
                    return { ...prev, sender: e };
                  });
                }}
              />
              <p
                className="text-danger mt-1"
                style={{
                  display: validate.user ? "none" : "block",
                  fontSize: 10,
                }}
              >
                کاربر را انتخاب کنید
              </p>
            </div>
            <div className="mt-4">
              <label
                style={{
                  color: "#677788",
                  fontSize: "0.75rem",
                  marginBottom: "0.5rem",
                }}
              >
                تاریخ
              </label>
              <DatePiker
                type_calender={"jalali"}
                // location={"right"}
                //   color={"purple"}
                //   bg={"bg-dark"}
                buttons={true}
                inputSize={"text"}
                value={entryStorage.date * 1000}
                setValue={(e) => {
                  setEntryStorage((prev) => {
                    return { ...prev, date: e.unix };
                  });
                }}
              ></DatePiker>
              <p
                className="text-danger mt-1"
                style={{
                  display: validate.date ? "none" : "block",
                  fontSize: 10,
                }}
              >
                تاریخ را وارد کنید
              </p>
            </div>
            <div className="my-4">
              <CustomInput
                label="توضیحات"
                inputType="textarea"
                inputSize="lg"
                inputValue={entryStorage.description}
                onChangeFunc={(e) => {
                  setEntryStorage((prev) => {
                    return { ...prev, description: e.target.value };
                  });
                }}
              ></CustomInput>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end mt-3">
            <CustomButton
              color="danger"
              className="mx-3"
              onClick={() => {
                setEntryShow(false);
                clearData();
              }}
            >
              انصراف
            </CustomButton>
            <CustomButton
              color="success"
              onClick={() => {
                if (validation()) {
                  enterBill();
                }
              }}
            >
              ثبت
            </CustomButton>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
